import React, { memo } from "react";
import { Controller } from "react-hook-form";

const ExistingId = ({ input, control, defaultValue, error }) => {
  const { name, type, defaultValues = defaultValue, ...rest } = input;

  return (
    <div
      key={name}
    >
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValues}
        render={({ field }) => (
          <>
            <input
              id={name}
              type='hidden'
              hidden
              {...field}
              {...rest}
            />
          </>
        )}
      />
    </div>
  );
};

export default memo(ExistingId);
